<template>
  <PageLayout class="osago-page">
    <PageTitle class="page-title">{{ quotationSearchTitle }}</PageTitle>
    <Breadcrumbs :breadcrumbs="breadcrumbs"/>
    <QuotationCalculator @change-title="changeTitle"/>
  </PageLayout>
</template>

<script>
import { mapActions } from 'vuex';
import QuotationCalculator from '../../views/quotations/quotationCalculator';
import { pages } from '@/entities/current-page';
import { PageLayout } from '@/shared/ui/layouts';
import { PageTitle } from '@/shared/ui/page-title';
import Breadcrumbs from "@/shared/ui/breadcrumbs/breadcrumbs/index.vue";

export default {
  created() {
    this.changeActivePage(pages.PRODUCTS_AND_PROPOSITIONS);
  },
  data() {
    return {
      quotationSearchTitle: 'Розрахунок вартості Котирування',
      breadcrumbs: [
        {
          title: 'Центр котирування',
        },
        {
          title: 'Розрахунок вартості',
        },
      ],
    }
  },
  components: { PageLayout, QuotationCalculator, PageTitle, Breadcrumbs },
  methods: {
    ...mapActions('currentPageModule', ['changeActivePage']),
    changeTitle(title) {
      if (title) {
        const titleChanged = 'Розрахунок вартості ' + title;
        this.quotationSearchTitle = titleChanged;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep button {
  text-align: center;
}

::v-deep input {
    border: 1px solid #dde2e5 !important;
    border-radius: 3px !important;

    &:hover {
        border-color: #ffad3d !important;
    }
}

::v-deep .multiselect__input {
    border: none !important;
}
.page-title {
  font-size: 30px;
  line-height: 44px;
  color: #24282c;
  font-weight: 700;
  margin-bottom: 26px !important;
}
</style>
